import { papelPrincipal } from '@/components/layout/menu'
// Papel complementar do GERENTE que gere a própria equipe (AN-8 §4; checkbox do DEV-M).
import { PAPEL_GESTOR_EQUIPE } from '@/types/usuario'

/**
 * O que cada persona pode na gestão comercial (campanhas, equipes, ranking) — espelho do
 * `SecurityRoles` do backend depois da AN-8 (Q-AN8-2, R1):
 *
 * | | ADMIN | GERENTE+GESTOR | GERENTE sem / OPERADOR | CONSULTOR |
 * |---|---|---|---|---|
 * | ler campanhas (`OPERADOR_OR_ABOVE`) | ✅ | ✅ | ✅ | ❌ |
 * | CRUD/status/excluir/audiência (`ADMIN_ONLY`) | ✅ | ❌ | ❌ | ❌ |
 * | participantes, produção, elegíveis, trilha (`GESTAO_CAMPANHA_EQUIPE`) | ✅ | só equipe | ❌ | ❌ |
 *
 * A tela só esconde; quem decide é o backend (403). A persona consultor segue o mesmo
 * critério do menu (`papelPrincipal`): CONSULTOR com OPERADOR residual continua consultor.
 */
export interface PermissoesGestaoComercial {
  ehAdmin: boolean
  /** GERENTE com GESTOR_EQUIPE (e sem ADMIN): gere só a própria equipe. */
  ehGestorEquipe: boolean
  /** Back-office (ADMIN, GERENTE, OPERADOR) — lê campanhas. */
  leCampanhas: boolean
  /** ADMIN_ONLY: criar, editar, status, excluir, audiência, sincronizar. */
  editaCampanha: boolean
  /** GESTAO_CAMPANHA_EQUIPE: participantes, produção, elegíveis, histórico, ranking admin. */
  geriParticipantes: boolean
}

export const permissoesGestaoComercial = (
  permissoes: string[] | undefined | null
): PermissoesGestaoComercial => {
  const p = (permissoes ?? []).map((x) => x.toUpperCase())
  const papel = papelPrincipal(p)
  const backoffice = papel === 'ADMIN' || papel === 'GERENTE' || papel === 'OPERADOR'
  const ehAdmin = papel === 'ADMIN'
  const ehGestorEquipe = papel === 'GERENTE' && p.includes(PAPEL_GESTOR_EQUIPE)
  return {
    ehAdmin,
    ehGestorEquipe,
    leCampanhas: backoffice,
    editaCampanha: ehAdmin,
    geriParticipantes: ehAdmin || ehGestorEquipe,
  }
}
